import DashDocuments from './DashDocuments.component';

export default DashDocuments;